import Vue from 'vue'
import {
  createPlatformState,
  platformAction,
  platformGetters,
  platformMutations
} from '~/helpers/store'

export default {
  state: () => createPlatformState(),
  actions: {
    async fetchCommunicationPreferences ({ commit }) {
      const prefs = await platformAction({
        client: this.$api.profiles.communicationPreferences,
        method: 'get',
        commit,
        logError: this.$logError,
        commitData: false
      })

      commit('savePrefs', prefs)
    },
    async updateCommunicationPreferences ({ commit }, params) {
      const prefs = await platformAction({
        client: this.$api.profiles.communicationPreferences,
        method: 'update',
        params,
        commit,
        logError: this.$logError,
        commitData: false
      })

      commit('savePrefs', prefs)
    }
  },
  getters: {
    ...platformGetters,
    communicationPreferences: s => s.data
  },
  mutations: {
    ...platformMutations,
    savePrefs: (s, prefs) => {
      Vue.set(s, 'data', prefs)
    }
  }
}
